import React from 'react'
import { Button, Modal } from 'antd'
import EquipmentDetailView from './EquipmentDetailView'

const EquipmentDetailModal = ({ equipment, showModal, onRefresh, onCancel }) => {
  return (
    <Modal
      title="История операций"
      visible={showModal}
      onCancel={onCancel}
      width={2500}
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
      ]}
    >
      <EquipmentDetailView equipment={equipment} onRefresh={onRefresh} />
    </Modal>
  )
}

export default EquipmentDetailModal
